import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../css/app.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import "bootstrap/dist/css/bootstrap.css";

const PopupJobFormApplicationComponent = ({
  activeID,
  jobListDetails,
  showModalForm,
}) => {
  let defaultField = [
    {
      name: "uploadResume",
      type: "file",
      placeholder: "",
      required: false,
      controlId: "formFile",
    },
    {
      name: "firstName",
      type: "text",
      placeholder: "",
      required: true,
      controlId: "firstName",
    },
    {
      name: "lastName",
      type: "text",
      placeholder: "",
      required: true,
      controlId: "lastName",
    },
    {
      name: "email",
      type: "email",
      placeholder: "",
      required: true,
      controlId: "email",
    },
    {
      name: "phone",
      type: "text",
      placeholder: "",
      required: true,
      controlId: "phone",
    },
    {
      name: "source",
      type: "text",
      placeholder: "",
      required: true,
      controlId: "source",
    },
    {
      name: "salutation",
      row: 3,
      as: "textarea",
      placeholder: "",
      required: true,
      controlId: "exampleForm.ControlTextarea1",
    },
  ];
  let defaultDetails = {
    firstName: "",
    source: "",
    salutation: "",
    email: "",
    phone: "",
    screening: {
      answers: [],
    },
  };
  const [showModal, setShowModal] = useState(false);
  const [jobTitle, setJobTitle] = useState(false);
  const [jobId, setJobId] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [fieldError, setFieldError] = useState([]);

  const [jobApplicationField, setJobApplicationField] = useState(defaultField);

  const [jobApplicationDetailsForm, setJobApplicationDetailsForm] =
    useState(defaultDetails);
  const [showLoadingMessage, setShowLoadingMessage] = useState(false);

  useEffect(() => {
    if (activeID !== false && jobListDetails.length > 0) {
      const foundItem = jobListDetails.find((item) => item.adId === activeID);

      setDestailJob(activeID);
      setJobId(activeID);
      setShowModal(!showModal);
      setJobApplicationDetailsForm(defaultDetails);
    }
  }, [showModalForm]);

  const setDestailJob = async (id) => {
    const foundItem = jobListDetails.find((item) => item.adId === id);

    if (foundItem) {
      if (foundItem.screening !== undefined) {
        const screeningField = foundItem.screening.map((item) => {
          return {
            name: item.question,
            type: item.answerType,
            placeholder: "",
            required: item.mandatory,
            controlId: "",
            isScreening: true,
          };
        });

        setJobApplicationField([...defaultField, ...screeningField]);
      } else {
        setJobApplicationField(defaultField);
      }
      setJobTitle(foundItem.title);
    } else {
    }
  };

  const validateForm = () => {
    const errors = {};
    jobApplicationField.forEach((field) => {
      if (
        field.required &&
        !jobApplicationDetailsForm[field.name] &&
        !field.isScreening
      ) {
        errors[field.name] = "This field is required."; // Customize error message
      }
      if (field.isScreening) {
        const screeningError = jobApplicationDetailsForm.screening.answers.find(
          (Aitem) => {
            if (Aitem !== undefined) {
              return Aitem.question === field.name;
            }
          }
        );

        if (screeningError?.question === undefined)
          errors[field.name] = "This field is required.";
      }
    });

    return errors;
  };

  const uploadFileToJobAdder = async (fileResume, candidateId) => {
    try {
      const paramsUpload = {
        action: "post_jobadder",
        nonce: react_ajax_object.ajax_react_nonce,
        endPoint: `candidates/${candidateId}/attachments/Resume`,
      };

      /*  const formData = new FormData();
          formData.append('fileData', fileResume); // Append file using FormData */
      const formData = { fileData: fileResume };
      const responseUpload = await axios.post(
        react_ajax_object.ajax_react,
        formData,
        {
          // Include params for security (e.g., nonce)
          params: paramsUpload,
          headers: {
            // Optional headers (if needed)
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return responseUpload.data;
    } catch (error) {
      console.error("Error uploading file to JobAdder:", error);
      throw error; // Re-throw the error for further handling
    }
  };

  const applyApplication = async (id) => {
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setFieldError(errors);
      return; // Don't submit if there are errors
    }
    setShowLoadingMessage(true);
    var loaderMessage = document.querySelector(".loader"),
      checkMessage = document.querySelector(".check");
    loaderMessage.classList.add("active");

    const foundItem = jobListDetails.find((item) => item.adId === id);

    try {
      const params = {
        action: "post_jobadder",
        nonce: react_ajax_object.ajax_react_nonce,
        endPoint: "jobs/" + foundItem.reference + "/applications/submit", // Consider template literals for readability
      };
      let orginalData = jobApplicationDetailsForm;
      const postData = orginalData;
      //   postData["fileData"] = null;
      if (postData.screening?.answers.length > 0) {
        postData.screening.answers = postData.screening.answers.reduce(
          (carry, item) => {
            if (item !== null) {
              carry.push(item);
              return carry;
            }
          },
          []
        );
      }

      //  return;
      const response = await axios.post(
        react_ajax_object.ajax_react,
        postData,
        {
          // Include params for security (e.g., nonce)
          params: params,
          headers: {
            // Optional headers (if needed)
            "Content-Type": "application/json",
          },
        }
      );
      const responseData = response.data;

      if (responseData.applicationId !== undefined) {
        // if(orginalData)
        if (orginalData?.fileData?.length > 0) {
          const fileResume = orginalData.fileData;
          let candidateId = responseData.candidate.candidateId;

          const responseDataUpload = await uploadFileToJobAdder(
            fileResume,
            candidateId
          );

          if (responseDataUpload.attachmentId !== undefined) {
            checkMessage.classList.add("active");

            setTimeout(function () {
              setShowLoadingMessage(false);
              setShowModal(false);
              setShowThankYou(true);
            }, 2000);
          }
        } else {
          checkMessage.classList.add("active");

          setTimeout(function () {
            setShowLoadingMessage(false);
            setShowModal(false);
            setShowThankYou(true);
          }, 2000);
        }
      } else {
        const errors = responseData;
        if (
          !jobApplicationDetailsForm.email ||
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(jobApplicationDetailsForm.email)
        ) {
          errors.email = ["Please enter a valid email address"];
        }
        setFieldError(errors);
      }
      if (!responseData) {
        console.error("No data found in the response");
        return;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const convertKeyword = (keyword) => {
    const conversionRegex = /([A-Z]|[a-z0-9]+)(_[A-Z]|[A-Z][a-z0-9]+)/g;

    let newWord = keyword.replace(conversionRegex, (match) => {
      // Split the matched string based on the delimiter
      const parts = match.split(/_|(?=[A-Z])/);

      // Simple conversion (lowercase first letter, join with spaces)
      const basicConversion = parts
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");

      // Consider using external resources (dictionaries, thesauri) for more accurate descriptions
      // (implementation details in approach 2)

      return basicConversion;
    });

    return newWord.charAt(0).toUpperCase() + newWord.slice(1);
  };

  return (
    <>
      <Modal
        size="lg"
        className="jobFormApplication"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>You are applying for: {jobTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="mainloader"
            style={{ display: showLoadingMessage ? "flex" : "none" }}
          >
            <div className="loader">
              <div className="check">
                <span className="check-one"></span>
                <span className="check-two"></span>
              </div>
            </div>
          </div>

          {!showLoadingMessage && (
            <Form>
              {jobApplicationField.map((itemField, index) => (
                <Form.Group className="mb-3" controlId={itemField.controlId}>
                  <Form.Label>{convertKeyword(itemField.name)}</Form.Label>
                  <Form.Control
                    type={itemField?.type}
                    as={itemField?.as}
                    row={itemField?.row}
                    required={itemField.required}
                    isInvalid={fieldError[itemField.name]}
                    error={
                      fieldError[itemField.name] &&
                      fieldError[itemField.name][0]
                    }
                    placeholder={itemField.placeholder}
                    onChange={(e) => {
                      if (!itemField.isScreening) {
                        if (itemField?.type === "file") {
                          setJobApplicationDetailsForm({
                            ...jobApplicationDetailsForm,
                            fileData: e.target.files,
                          });
                        } else {
                          setJobApplicationDetailsForm({
                            ...jobApplicationDetailsForm,
                            [itemField.name]: e.target.value,
                          });
                        }
                        // setJobApplicationDetailsForm({...jobApplicationDetailsForm , [itemField.name] : e.target.value })
                      } else {
                        const addScreen = jobApplicationDetailsForm;
                        addScreen.screening.answers[index] = {
                          question: itemField.name,
                          answer: e.target.value,
                        };
                        setJobApplicationDetailsForm(addScreen);
                      }
                    }}
                  />
                </Form.Group>
              ))}
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!showLoadingMessage && (
            <Button
              className="apply-button"
              variant="primary"
              onClick={() => applyApplication(activeID)}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        className="thank-you-page-form"
        show={showThankYou}
        onHide={() => setShowThankYou(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Thank You!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Thank you for your submission!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowThankYou(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default PopupJobFormApplicationComponent;
